import { Stack, Typography } from '@mui/material';
import { BlacklistScopes } from 'features/co-pilot/campaign-builder/campaign-builder.types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  activeBlacklistScope: BlacklistScopes;
  totalGlobalBlacklists: number;
  totalLocalBlacklists: number;

  handleBlacklistScopeChange(newType: BlacklistScopes): () => void;
}

const BlacklistsTab: React.FC<Props> = ({ activeBlacklistScope, totalGlobalBlacklists, totalLocalBlacklists, handleBlacklistScopeChange }) => {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();

  return (
    <Stack direction={'row'} gap={1}>
      <Stack className={classes.tabs} direction={'row'} sx={{ width: 'calc(100% - 250px)' }}>
        <Stack
          className={cx(classes.tab, activeBlacklistScope === BlacklistScopes.GLOBAL ? 'active' : undefined)}
          gap={0.5}
          onClick={handleBlacklistScopeChange(BlacklistScopes.GLOBAL)}
        >
          <Typography className={classes.tabPrimaryText}>{t('globalBlacklists', { count: totalGlobalBlacklists })}</Typography>
          <div className={classes.activeIndicator} />
        </Stack>
        <Stack
          className={cx(classes.tab, activeBlacklistScope === BlacklistScopes.LOCAL ? 'active' : undefined)}
          gap={0.5}
          onClick={handleBlacklistScopeChange(BlacklistScopes.LOCAL)}
        >
          <Typography className={classes.tabPrimaryText}>{t('campaignSpecificBlacklists', { count: totalLocalBlacklists })}</Typography>
          <div className={classes.activeIndicator} />
        </Stack>
      </Stack>
    </Stack>
  );
};

const useStyles = makeStyles<void, 'tabPrimaryText' | 'activeIndicator'>()((theme, _params, classes) => ({
  tabs: {
    background: '#FFF',
    borderRadius: '12px',
    width: '100%',
  },
  tab: {
    position: 'relative',
    cursor: 'pointer',
    padding: '4px 16px 8px 16px',
    '&:hover': {
      [`& .${classes.tabPrimaryText}`]: {
        color: theme.palette.primary.main,
      },
    },
    '&.active': {
      [`& .${classes.tabPrimaryText}`]: {
        color: theme.palette.primary.main,
      },
      [`& .${classes.activeIndicator}`]: {
        visibility: 'visible',
      },
    },
  },
  activeIndicator: {
    visibility: 'hidden',
    position: 'absolute',
    bottom: '0px',
    left: '16px',
    width: 'calc(100% - 32px)',
    height: '4px',
    background: theme.palette.primary.main,
    borderRadius: '4px',
  },
  tabPrimaryText: {
    fontSize: theme.typography.pxToRem(16),
    marginTop: '4px',
  },
  regularText: {
    fontSize: theme.typography.pxToRem(15),
  },
}));

export default BlacklistsTab;
